import React from 'react';
import { FadeIn } from './Shared';
import { XCircle } from 'lucide-react';
export const PainSection = () => {
  const pains = ['Le guardás el turno a alguien sin seña y te lo cancela el día antes — y ya perdiste el material y el tiempo', 'Respondés consultas por WhatsApp escribiendo desde cero cada vez y la mitad te deja en visto después de dar el precio', 'Cada semana improvisás cómo pedir la seña y según el día cedés o no cedés sin criterio claro', 'Sentís que trabajás mucho pero que tu negocio no crece porque seguís atando todo con alambre', 'El domingo a la noche ya calculás qué tan floja va a ser la semana que viene'];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-213">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_100%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-214"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-215">
        <FadeIn data-id="element-216">
          <h2 className="text-3xl md:text-5xl text-white mb-10 text-center leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-217">
            ¿Cuántos turnos vacíos <br className="hidden md:block" data-id="element-218" />
            <span className="text-pink-400" data-id="element-219">
              más vas a bancar sin tener un sistema?
            </span>
          </h2>

          <div className="mx-auto mb-12 text-gray-200 text-center space-y-6 text-base md:text-lg font-sans opacity-95 leading-relaxed" data-id="element-220">
            <p data-id="element-221">
              Sos una profesional que ama lo que hace. Aprendiste tu oficio,
              invertiste en materiales, construiste tu clientela. Pero nadie te
              enseñó a gestionar todo lo que pasa alrededor del servicio.
            </p>
            <p data-id="element-222">
              Las cancelaciones de último momento. Los plantones. Las que piden
              turno y desaparecen. Las que nunca transfieren la seña. Y vos,
              perdiendo horas, plata y energía cada semana sin saber exactamente
              por qué.
            </p>
          </div>

          <div className="flex justify-center mb-12" data-id="element-223">
            <div className="bg-gradient-to-r from-pink-500/10 via-pink-500/20 to-pink-500/10 border-y border-pink-500/30 py-6 px-8 w-full max-w-2xl text-center" data-id="element-224">
              <p className="font-bold text-white uppercase tracking-[0.15em] text-lg md:text-2xl font-sans leading-snug" data-id="element-225">
                No es que tus clientas sean un problema.
                <br className="md:hidden" data-id="element-226" />{' '}
                <span className="text-pink-400" data-id="element-227">
                  Es que nadie te dio las herramientas correctas.
                </span>
              </p>
            </div>
          </div>

          <div className="bg-navy-900/60 border border-white/10 rounded-3xl p-6 md:p-10 mb-12" data-id="element-228">
            <p className="text-white font-bold text-lg mb-6 text-center" data-id="element-229">
              Tu agenda tiene huecos que nadie llena porque no tenés un sistema
              de lista de espera ni de reactivación activo
            </p>
            <ul className="space-y-6" data-id="element-230">
              {pains.map((pain, index) => <li key={index} className="flex items-start" data-id="element-231">
                  <XCircle className="w-5 h-5 md:w-6 md:h-6 text-pink-500 mr-4 flex-shrink-0 mt-0.5" data-id="element-232" />
                  <span className="text-base md:text-lg text-gray-100 font-sans leading-relaxed" data-id="element-233">
                    {pain}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-234">
            <h3 className="text-2xl md:text-4xl text-pink-400 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-235">
              ¿Y si la próxima consulta que llegue se convirtiera en turno
              confirmado con seña — sin que tengas que improvisar nada?
            </h3>
          </div>
        </FadeIn>
      </div>
    </section>;
};